import { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { getSelectedAccountIds, getSelectedAccountsSubject } from '../../../store/User';

export const AdviseAccountGuard = ({ children }: { children: React.ReactNode }) => {
  const [accountIds, setAccountIds] = useState<string[] | undefined>(getSelectedAccountIds());

  useEffect(() => {
    const sub = getSelectedAccountsSubject().subscribe(() => {
      setAccountIds(getSelectedAccountIds());
    });
    return () => sub.unsubscribe();
  }, []);

  if (!accountIds?.length || accountIds.length > 1) {
    return (
      <Box className="mt-4">
        <Alert severity="info">Please select a single account from the account picker to view Advise data.</Alert>
      </Box>
    );
  }

  return <>{children}</>;
};
